import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { FileButtonComponent } from 'common-ui';
import { CommonProductDetailsComponentBase } from '../../CommonProductDetailsComponentBase';

@Component({
  selector: 'ideal-product-download-spec-sheet-button',
  imports: [FileButtonComponent],
  templateUrl: './product-download-spec-sheet-button.component.html',
  styleUrl: './product-download-spec-sheet-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.loading]': 'loading()',
    '[class.no-content]': '!hasContent()',
  },
})
export class ProductDownloadSpecSheetButtonComponent extends CommonProductDetailsComponentBase {
  protected readonly specSheetUrl = computed(() => this.productDetails()?.specSheetUrl ?? '');
}
